/**
 * @desc Snowmaking hydrants state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "standard",
    layerTitle: "Standard",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: true,
    splitIndex: 0,
    legend: [
      {
        id: 1,
        name: "Beginner",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Beginner_Sled.png"
      },
      {
        id: 2,
        name: "Intermediate",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Intermediate_Sled.png"
      },
      {
        id: 3,
        name: "Advanced",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Advanced_Sled.png"
      },
      {
        id: 4,
        name: "Caution/Hazard",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Caution_Sled.png"
      },
      {
        id: 5,
        name: "Road stripped",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Road_Stripped_Sled.png"
      },
      {
        id: 6,
        name: "Closed",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/designatedroutes/Closed_Sled.png"
      }
    ]
  }
};
